import moment from 'moment-timezone'

const execTimeStampStr = (val) => {
  return !!val && /^\d+$/.test(val.toString()) ? Number(val) : val
}
const filters = {
  //  统一管理要绑定的指令
  Date: (val) => {
    if (!val && val !== 0) {
      return '-'
    }
    const momentDate = moment(execTimeStampStr(val))
    return momentDate.isValid() ? momentDate.format('DD/MM/YYYY') : '-'
  },
  zhDate: (val) => {
    if (!val && val !== 0) {
      return '-'
    }
    const momentDate = moment(execTimeStampStr(val))
    return momentDate.isValid() ? momentDate.format('YYYY-MM-DD') : '-'
  },
  Time: (val) => {
    if (!val && val !== 0) {
      return '-'
    }
    const momentDate = moment(execTimeStampStr(val))
    return momentDate.isValid() ? momentDate.format('HH:mm:ss') : '-'
  },
  DateTime: (val, changeTimezone) => {
    if (!val && val !== 0) {
      return '-'
    }
    const momentDate = moment(execTimeStampStr(val))
    if (changeTimezone) {
      return momentDate.isValid() ? momentDate.tz('Indian/Christmas').format('DD/MM/YYYY HH:mm:ss') : '-'
    }
    // 设置时区为金边时间（东7区）
    return momentDate.isValid()
        ? momentDate.format('DD/MM/YYYY HH:mm:ss')
        : '-'
  },
  DateFormat: (val, formatStr) => {
    if (!val && val !== 0) {
      return '-'
    }
    const momentDate = moment(execTimeStampStr(val))
    return momentDate.isValid() ? momentDate.format(formatStr) : '-'
  },
  AmtThousandsFmt: data => {
    if (!data) {
      return '0.00';
    }
    const ret = ((parseFloat(((data - 0) || 0), 10) - 0).toFixed(2)).toLocaleString() || data.toString();
    return ret === '0' && '0.00' || (ret.indexOf('.') === -1 && `${ret}.00` || ret);
  },
  AmtDecimalsFmt: (num, n = 2) => {
    num = parseFloat((num + '').replace(/[^\d\.-]/g, '')).toFixed(n) + ''
    const l = num.split('.')[0].split('').reverse()
    const r = num.split('.')[1]
    let t = ''
    for (let i = 0; i < l.length; i++) {
      t += l[i]
    }
    return (t.split('').reverse().join('') + '.' + r)
  },
  AmtNullFmt: num => isNaN(Number(num)) ? 0 : Number(num),
  toThousandFilter: num => (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}
export default {
  install() {
    Object.keys(filters).forEach(key => {
      Vue.filter(key, filters[key]);
    });
  }
};
